// extracted by mini-css-extract-plugin
export default {"root":"tGOBvqnJ","add_file":"_Gq3aQo9","more_file":"XWCK3gUY","smallSize":"TyFzFzyb","addMediaContainer":"PVMQOwdE","addMediaText":"zCwJudwQ"};